import React from "react";
import { Route, Switch } from "react-router-dom";
import CreatePassword from "./Authentication/CreatePassword";
import ForgotPassword from "./Authentication/ForgotPassword";
import ErrorPage from "./ErrorPage/ErrorPage";

export const PublicRoutes = {
  ResetPassword: "/resetPassword",
  ChangePassword: "/changePassword",
  ErrorPage: "/error",
};

const PublicRouteSwitch: React.FC = () => {
  return (
    <Switch>
      <Route path={PublicRoutes.ResetPassword}>
        <ForgotPassword />
      </Route>

      <Route path={PublicRoutes.ChangePassword}>
        <CreatePassword />
      </Route>

      <Route path={PublicRoutes.ErrorPage}>
        <ErrorPage />
      </Route>
    </Switch>
  );
};

export default PublicRouteSwitch;
